import React from "react";
import {
  updatePrimaryDiet,
  updateUnitPreference,
  updateIsDairyFree,
} from "../redux/user/userSlice";
import { useDispatch } from "react-redux";

const RadioButton = ({ id, name, value, userPreference }) => {
  const dispatch = useDispatch();

  const style = { boxShadow: "none" };

  const handleSelection = (e) => {
    const selectedValue = e.target.value;

    if (e.target.name === "preference") {
      dispatch(updateUnitPreference(selectedValue));
      return;
    }

    // ✅ Primary Diet radios
    if (selectedValue === "Dairy Free") {
      // keep primary diet stable (backend likely expects omnivore/veg/vegan)
      dispatch(updatePrimaryDiet("Omnivore"));
      dispatch(updateIsDairyFree(true));
    } else {
      dispatch(updatePrimaryDiet(selectedValue));
      dispatch(updateIsDairyFree(false));
    }
  };

  return (
    <div>
      <input
        className="cursor-pointer mr-2.5 text-wwlOrange"
        style={style}
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={userPreference === value}
        onChange={handleSelection}
      />
      <label className="font-inter text-sm cursor-pointer" htmlFor={id}>
        {value}
      </label>
    </div>
  );
};

export default RadioButton;
